import { Button } from '../Button/Button'
import { count, root } from './LoadMore.css'

export type LoadMoreProps = {
  onClick: () => void
  loading?: boolean
  shown: number
  total?: number
  hasMore: boolean
  label?: string
  error?: boolean
  errorMessage?: string
  retryLabel?: string
  summaryLabel?: (shown: number, total?: number) => string
}

export function LoadMore({
  onClick,
  loading = false,
  shown,
  total,
  hasMore,
  label = 'Carregar mais',
  error = false,
  errorMessage = 'Não foi possível carregar mais itens.',
  retryLabel = 'Tentar novamente',
  summaryLabel,
}: LoadMoreProps) {
  const summary = summaryLabel
    ? summaryLabel(shown, total)
    : total != null
      ? `${shown} de ${total}`
      : `${shown}`

  return (
    <div className={root}>
      {error ? (
        <>
          <span className={count} role="alert">
            {errorMessage}
          </span>
          <Button variant="secondary" size="sm" disabled={loading} onClick={onClick}>
            {loading ? 'Tentando novamente…' : retryLabel}
          </Button>
        </>
      ) : hasMore ? (
        <Button variant="secondary" size="sm" disabled={loading} onClick={onClick}>
          {loading ? 'Carregando…' : label}
        </Button>
      ) : null}
      <span className={count}>{summary}</span>
    </div>
  )
}
